import axios from "axios"
import { getUrl, getErrorMessage, headers } from "../networkconfig"

const login = async (email: string, password: string) => {
  const endpoint = `login`
  const url = getUrl(endpoint)

  try {
    const { data } = await axios.post(url, {email, password}, {
      headers: {
        ...headers
      }
    })
    if (!data.status) return { error: "Request error" }

    return parseResponse(data)
  } catch (error) {
    return getErrorMessage(error)
  }
}

const parseResponse = (response: any) => {
  return response
}

export default login